import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import Icon, { ICON_NAMES } from "components/Icon";
import Button from "components/Button";
import history from "services/history";
import ROUTES from "config/routes";
import TitleIcon from "components/TitleIcon";

class PageTitle extends Component {
  render() {
    const {
      title,
      align,
      isBackButton,
      registration,
      children,
      favoriteButton,
      linkTitle,
      linkText,
      onFavoriteClick,
      isFavorite,
    } = this.props;

    return (
      <div className="page-title-container">
        <div className="container">
          <div className="row">
            <div className="col-12">
              {registration && (
                <div className="page-title-registration">
                  <div className="page-title-registration__text">
                    Don’t have an account?
                  </div>
                  <Button to={ROUTES.signUp}>REGISTER HERE</Button>
                </div>
              )}
              {isBackButton && (
                <Button
                  onClick={() => history.goBack()}
                  bgColor="white"
                  className="btn-back btn-icon"
                >
                  <span className="btn__icon-container">
                    <Icon name={ICON_NAMES.arrowBack} className="btn__icon" />
                  </span>
                  <span className="btn__text">GO BACK</span>
                </Button>
              )}
              {favoriteButton && (
                <Button
                  onClick={onFavoriteClick}
                  bgColor="white"
                  className={classNames("btn-favorite btn-icon", {
                    "btn-favorite--active": isFavorite,
                  })}
                >
                  <span className="btn__icon-container">
                    <Icon
                      name={ICON_NAMES.favorite}
                      active={isFavorite}
                      className="btn__icon"
                    />
                  </span>
                </Button>
              )}
              <div className="row">
                <div className="col-12 col-lg-8 offset-lg-2">
                  <div
                    className={classNames("page-title-wrapper", {
                      [`page-title-wrapper--${align}`]: align != null,
                    })}
                  >
                    <TitleIcon withTm={true}></TitleIcon>

                    <div className="page-title-wrapper__text">
                      <h1 className="page-title">{title || children}</h1>
                      {linkText && (
                        <Button to={linkText} bgColor="transparent" width="min">
                          {linkTitle || linkText}
                        </Button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

PageTitle.propTypes = {
  align: PropTypes.oneOf(["left", "center"]),
  isBackButton: PropTypes.bool,
  registration: PropTypes.bool,
  favoriteButton: PropTypes.bool,
  onFavoriteClick: PropTypes.func,
};

PageTitle.defaultProps = {
  align: "left",
  isBackButton: false,
  registration: false,
  favoriteButton: false,
};

export default PageTitle;
